
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-99fc0a70\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalVisualisationDetailsDsn.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalVisualisationDetailsDsn.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-99fc0a70\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalVisualisationDetailsDsn.vue.html"),
  /* scopeId */
  "data-v-99fc0a70",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dsn/modalVisualisationDetailsDsn/modalVisualisationDetailsDsn.vue.html
// module id = d92U
// module chunks = 2